<div class="system-updates-list">
  @for (entry of systemUpdate.history; track entry.version + '-' + entry.revision) {
    <div class="system-updates-entry">
      <div class="system-updates-entry-meta">
        Ver: {{ entry.version }} · Rev: {{ entry.revision }}
      </div>
      <ul>
        @for (item of entry.items; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </div>
  }
</div>
